import {
  Search,
  Package,
  Users,
  BarChart3,
  FileText,
  Star,
} from 'lucide-react';

export interface SearchResult {
  id: string;
  title: string;
  type: 'service' | 'site' | 'article' | 'order' | 'deal';
  description: string;
  category?: string;
  url: string;
  metadata?: Record<string, unknown>;
}

export const mockResults: SearchResult[] = [
  {
    id: '1',
    title: 'Guest Post Services',
    type: 'service',
    description: 'High-quality guest posting with DA 50+ sites',
    category: 'Content Marketing',
    url: '/services',
    metadata: { price: '$299', rating: 4.8 },
  },
  {
    id: '2',
    title: 'techcrunch.com',
    type: 'site',
    description: 'Premium tech publication with massive reach',
    category: 'Technology',
    url: '/browse-sites',
    metadata: { da: 92, traffic: '2.5M' },
  },
  {
    id: '3',
    title: 'Getting Started Guide',
    type: 'article',
    description: 'Complete guide to your first campaign',
    category: 'Help Center',
    url: '/help',
    metadata: { readTime: '5 min', helpful: 142 },
  },
];

export const recentSearches = [
  'guest posts',
  'tech sites',
  'DA 70+',
  'content writing',
];
export const trendingSearches = [
  'AI websites',
  'crypto blogs',
  'health sites',
  'finance publications',
];

export const getResultIcon = (type: string) => {
  switch (type) {
    case 'service':
      return Package;
    case 'site':
      return BarChart3;
    case 'article':
      return FileText;
    case 'order':
      return Users;
    case 'deal':
      return Star;
    default:
      return Search;
  }
};
